import PropTypes from "prop-types";
import classNames from "classnames";
import styles from "./AddNoteButton.module.css";
import add from "./add.svg";

/**
 * Interactive component, a button that takes a function as a parameter
 */
export function AddNoteButton({ onClick }) {
  return (
    <>
      <button
        className={classNames(
          styles.add_note_button,
          styles.inline,
          styles.borderless
        )}
        onClick={onClick}
      >
        <img src={add} className={styles.image} />
        <div className={classNames(styles.add_note_text, styles.inline)}>
          ADD NOTE
        </div>
      </button>
    </>
  );
}

AddNoteButton.propTypes = {
  onClick: PropTypes.func,
};
